import { AgmCoreModule } from '@agm/core';
import { AgmMarkerClustererModule } from '@agm/markerclusterer';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from 'src/app/shared/shared.module';
import { environment } from '../../../environments/environment';
import { AddMediaComponent } from './add-media/add-media.component';
import { UploadValidationModalComponent } from './add-media/upload-validation-modal/upload-validation-modal.component';
import { UploadService } from './add-media/upload.service';
import { AddTitleComponent } from './add-title/add-title.component';
import { CampaignSummaryComponent } from './campaign-summary/campaign-summary.component';
import { ChannelsLocationComponent } from './channels-location/channels-location.component';
import { CompletePaymentComponent } from './complete-payment/complete-payment.component';
import { ConfirmCampaignCreationModalComponent } from './confirm-campaign-creation-modal/confirm-campaign-creation-modal.component';
import { ScheduleDirective } from './directives/schedule.directive';
import { HeaderComponent } from './header/header.component';
import { CampaignOverviewComponent } from './media-plan-overview/campaign-overview/campaign-overview.component';
import { ChannelPerformanceComponent } from './media-plan-overview/channel-performance/channel-performance.component';
import { MediaOverviewComponent } from './media-plan-overview/media-overview/media-overview.component';
import { MediaPlanOverviewComponent } from './media-plan-overview/media-plan-overview.component';
import { EditMediaComponent } from './medias-overview/edit-media/edit-media.component';
import { MediasOverviewComponent } from './medias-overview/medias-overview.component';
import { NewCampaignRoutingModule } from './new-campaign-routing.module';
import { NewCampaignComponent } from './new-campaign.component';
import { ProductScheduleComponent } from './product-schedule/product-schedule.component';
import { PublishCampaignModalComponent } from './publish-campaign-modal/publish-campaign-modal.component';
import { PublishSuccessModalComponent } from './publish-success-modal/publish-success-modal.component';
import { PauseCampaignVisualModalComponent } from './add-media/pause-campaign-visual-modal/pause-campaign-visual-modal.component';
import { ConfirmExitModalComponent } from './confirm-exit-modal/confirm-exit-modal.component';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';

@NgModule({
    declarations: [
        NewCampaignComponent,
        AddTitleComponent,
        HeaderComponent,
        ChannelsLocationComponent,
        ProductScheduleComponent,
        AddMediaComponent,
        MediasOverviewComponent,
        EditMediaComponent,
        CampaignSummaryComponent,
        MediaPlanOverviewComponent,
        CampaignOverviewComponent,
        ConfirmExitModalComponent,
        MediaOverviewComponent,
        ChannelPerformanceComponent,
        PauseCampaignVisualModalComponent,
        PublishCampaignModalComponent,
        ConfirmCampaignCreationModalComponent,
        CompletePaymentComponent,
        PublishSuccessModalComponent,
        ScheduleDirective,
        UploadValidationModalComponent
    ],
    imports: [
        CommonModule,
        NewCampaignRoutingModule,
        SharedModule,
        AgmCoreModule.forRoot({
            apiKey: `${environment.agmKey}`
        }),
        AgmSnazzyInfoWindowModule,
        AgmMarkerClustererModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule
    ],
    providers: [CanDeactivateGuard, UploadService],
    entryComponents: [
        EditMediaComponent,
        PublishCampaignModalComponent,
        PauseCampaignVisualModalComponent,
        PublishSuccessModalComponent,
        ConfirmCampaignCreationModalComponent
    ]
})
export class NewCampaignModule { }
